var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"btn-box",on:{"click":function($event){return _vm.goUrl(_vm.buttonLink)}}},[_c('div',{staticClass:"btn"},[_vm._v(_vm._s(_vm.buttonText))])]),_vm._v(" "),_c('div',{staticClass:"footer-copyright-box"},[_vm._v(_vm._s(_vm.copyrightText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672c5805","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer-menu.vue
// module id = 305
// module chunks = 0